import { Typography, Stack, Card, Divider } from '@mui/material';
import { t } from 'i18next'
import { THubstripeCustomer } from "../../../shared/types/hubstripeCustomer.type";
import dayjs from 'dayjs';


type BillingInformationsProps = {
    customer: THubstripeCustomer | null
}

function BillingInformations({ customer }: BillingInformationsProps) {

    return (
        <Card sx={{ p: 3 }}>
            {customer != null && (
                <Stack spacing={0} position={'relative'}>
                    <Typography variant="h5" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                        {t("billing:informations")}
                    </Typography>
                    <Divider sx={{mt:2}}/>
                    <Typography mt={2} variant="subtitle2" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                        {t("billing:id")}
                    </Typography>
                    <Typography variant='body2' noWrap>{customer?.id ?? ""}</Typography>

                    <Typography mt={2} variant="subtitle2" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                        {t("billing:email")}
                    </Typography>
                    <Typography variant='body2' noWrap >{customer?.email ?? ""}</Typography>


                    {
                        customer?.created && <>
                            <Typography mt={2} variant="subtitle2" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                                {t("billing:customer_since")}
                            </Typography>
                            <Typography variant='body2' noWrap>
                                {dayjs.unix(customer?.created).format('DD/MM/YYYY')}
                            </Typography>

                        </>
                    }

                </Stack>
            )
            }
        </Card>
    );
}

export default BillingInformations;
